import React from 'react';

/**
 * Cosa si vede mentre il sito ci riporta all'accesso.
 *
 * Nessun link: qualunque indirizzo si mettesse qui sarebbe il modulo di accesso
 * di Open edX, cioe' esattamente quello che si sta togliendo di mezzo. A
 * riportare l'utente all'SSO ci pensa il sito, che ha appena ricevuto
 * `igea:sessione-scaduta` (vedi `sessione-scaduta.js`).
 *
 * Il testo e' in italiano e non passa da `react-intl`: questo schermo vive solo
 * dentro il player IGEA, dove la lingua e' una sola, e farlo passare dalle
 * traduzioni vorrebbe dire aggiungere una chiave al catalogo upstream per una
 * frase che upstream non disegna mai.
 */
const AccessoInCorso = () => (
  <div
    className="d-flex align-items-center justify-content-center text-center"
    style={{ minHeight: '100vh', padding: '2rem' }}
    data-testid="igea-accesso-in-corso"
  >
    <div>
      <p className="h4 mb-2">La sessione &egrave; scaduta</p>
      <p className="text-muted mb-0">Ti stiamo riportando all&apos;accesso.</p>
    </div>
  </div>
);

export default AccessoInCorso;
